import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth: '100%'}}
                                                 src={require('@images/How to direct people.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>The red cross on white background was the original protection
                                                symbol declared at the 1864 Geneva Convention:</p>
                                            <div className="border_subtitle">Getting others on board</div>
                                            <p>The International Red Cross stands as an impartial, neutral and
                                                independent organisation for the
                                                protection of the life and dignity of victims of international
                                                and internal armed conﬂicts. With over 96 million members
                                                worldwide it is a huge job to get people to meet these needs. So
                                                how do you get people to work towards a shared goal?
                                                Psychologists would point you to social inﬂuence theory<sup><a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300">1</a></sup> to explain
                                                how people can be persuaded and inﬂuenced. Principally, social
                                                inﬂuence is changing someone's behaviour, intentionally or
                                                unintentionally, based on how the changed person perceives the
                                                inﬂuencer, other people or society in general. There are three
                                                areas of social inﬂuence: conformity, compliance and obedience.
                                                Conformity is changing how you behave to be more like others;
                                                compliance is when a person does something that they are asked
                                                to do by another; and obedience is obeying an order from someone
                                                you accept as an authority figure. The
                                                research example below shows one method of persuading others.
                                            </p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">The best request</div>
                                                <p>During a research project,<sup><a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300">2</a></sup> participants
                                                    were given two requests with the direct intention of
                                                    one being rejected but by doing so making the other request
                                                    more desirable. The researchers asked the participants to
                                                    give one pint of blood either the following day, or every
                                                    six weeks for the next year. The students rejected the
                                                    latter request but then when
                                                    asked to give blood the following day they were much more
                                                    likely to do so. </p>
                                                <p>The researchers felt that this was due to the contrast
                                                    effect, where an extreme request
                                                    makes a lesser request more reasonable. People were also
                                                    more likely to agree if the initial request was withdrawn,
                                                    as it seemed to make individuals feel that they should give
                                                    something back in return (e.g. by giving blood the next
                                                    day). </p>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought"> Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}